import styles from './index.module.less';
import Image from 'next/image';
const Index = ({ hero, confirm }: { hero: any; confirm: () => void }) => {
  return (
    <div className={styles.container}>
      <div className={styles.bg}>
        <Image src={hero.imgPath} alt={hero.title} width={1200} height={448} priority />
      </div>
      <div className={styles.vs}>{hero.subTitle}</div>
      <div className={styles.title}>{hero.title}</div>
      <h1 style={{ display: 'none' }}>{hero.title}</h1>
      <div className={styles.desc}>{hero.desc}</div>
      <div className={styles.btn} onClick={confirm}>
        {hero.buttonLabel}
      </div>
    </div>
  );
};

export default Index;
